import type { Client } from "@/types/clients/api-types/client-types";
import { isoDate } from "@/lib/utils";

export type ClientFormValues = {
  first_name: string;
  last_name: string;
  preferred_name: string;
  pronouns: string;
  phone: string;
  email: string;
  address: string;
  recommended_by: string;
  birthday: Date | null;
  notes: string;
};

const parseIsoDate = (value: string | null | undefined): Date | null => {
  if (!value) return null;
  const date = isoDate(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const getClientFormValues = (client?: Client): ClientFormValues => {
  if (!client) {
    return {
      first_name: "",
      last_name: "",
      preferred_name: "",
      pronouns: "",
      phone: "",
      email: "",
      address: "",
      recommended_by: "",
      birthday: null,
      notes: "",
    };
  }

  return {
    first_name: client.first_name,
    last_name: client.last_name,
    preferred_name: client.preferred_name ?? "",
    pronouns: client.pronouns ?? "",
    phone: client.phone ?? "",
    email: client.email,
    address: client.address ?? "",
    recommended_by: client.recommended_by ?? "",
    birthday: parseIsoDate(client.birthday),
    notes: client.notes ?? "",
  };
};
